import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, H2, Reviews } from '../../components';

import css from './ListingPage.module.css';

const SectionReviews = props => {
  const { reviews, fetchReviewsError, name } = props;
  const firstName = typeof name === 'string' ? name.trim().split(/\s+/)[0] : '';
  const hasReviews = reviews.length > 0;

  return (
    <section className={css.sectionReviews}>
      <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
        {hasReviews ? (
          <FormattedMessage id="ListingPage.reviewsTitle" values={{ count: reviews.length }} />
        ) : (
          <FormattedMessage id="ListingPage.profile.reviewsTitle" />
        )}
      </Heading>
      {fetchReviewsError ? (
        <H2 className={css.errorText}>
          <FormattedMessage id="ListingPage.reviewsError" />
        </H2>
      ) : null}
      {hasReviews ? (
        <Reviews reviews={reviews} />
      ) : fetchReviewsError ? null : (
        <p className={css.reviewsEmpty}>
          <FormattedMessage id="ListingPage.profile.reviewsEmpty" values={{ name: firstName }} />
        </p>
      )}
    </section>
  );
};

export default SectionReviews;
